import * as CssLoader from './loader';
export { CssLoader };
//# sourceMappingURL=index.js.map